import { Truck, MessageCircle } from "lucide-react";
import { useStoreConfig } from "../../features/config/queries";

// Real, always-true claims only — no invented thresholds or stats.
export function AnnouncementBar() {
  const { data: config } = useStoreConfig();
  const whatsappNumber = config?.whatsappNumber?.replace(/[^\d]/g, "");

  return (
    <div className="bg-[#050813] text-[#f6f1e7]/80 text-xs">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 h-9 flex items-center justify-center gap-2 sm:gap-3 text-center overflow-hidden">
        <span className="flex items-center gap-1.5 whitespace-nowrap truncate">
          <Truck size={12} className="text-[#dcb662] shrink-0" aria-hidden />
          <span className="truncate">Cash on delivery nationwide</span>
        </span>
        {whatsappNumber && (
          <>
            <span className="hidden sm:inline text-[#f6f1e7]/25" aria-hidden>
              |
            </span>
            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noreferrer"
              className="hidden sm:flex items-center gap-1.5 whitespace-nowrap hover:text-[#f6f1e7] transition-colors duration-200 shrink-0"
            >
              <MessageCircle size={12} className="text-[#dcb662] shrink-0" aria-hidden />
              Questions? Chat with us on WhatsApp
            </a>
          </>
        )}
      </div>
    </div>
  );
}
